module.exports = __webpack_public_path__ + "static/media/24UHCHR8.1e0fcf39.jpg";